module.exports = __webpack_public_path__ + "img/pre-university-learning.a7c06a4e.png";